import React from 'react'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import { CarouselComponent } from '../../ui/carousel'
import { Media } from '../../ui/medias/Media'
import { ModalWithMedias } from '../../ui/medias/ModalWithMedia'

interface OfferMediasProps {
  medias: IGatsbyImageData[] | string[] | null
  companyName: string | null
}

const OfferMedias: React.FC<OfferMediasProps> = ({ medias, companyName }) => {
  if (!medias || medias.length === 0) {
    return null
  }
  const firstMedia = medias[0]
  return (
    <section>
      {medias.length > 1 ? (
        <CarouselComponent>
          {medias.map((media, index: number) => {
            if (media) {
              return (
                <div
                  // eslint-disable-next-line react/no-array-index-key
                  key={`carousel-${index}`}
                  className="h-[360px] md:h-[450px] xl:h-[550px] flex items-center justify-center"
                >
                  <Media
                    id={index.toString()}
                    video={false}
                    media={media}
                    name={companyName ?? ''}
                  />
                </div>
              )
            }
            return null
          })}
        </CarouselComponent>
      ) : (
        <div className="flex items-center justify-center rounded-xl">
          <ModalWithMedias
            id={firstMedia.id}
            media={firstMedia}
            name={companyName ?? ''}
            video={false}
            youTubeApiKey={null}
          />
        </div>
      )}
    </section>
  )
}
export default OfferMedias
